export const GET_ENQUIRY_CONVERSION_RATE_REPORT = 'GET_ENQUIRY_CONVERSION_RATE_REPORT'
export const GET_ENQUIRY_CONVERSION_RATE_REPORT_SUCCESS = 'GET_ENQUIRY_CONVERSION_RATE_REPORT_SUCCESS'
export const GET_ENQUIRY_CONVERSION_RATE_REPORT_FAILED = 'GET_ENQUIRY_CONVERSION_RATE_REPORT_FAILED'

export const CLEAR_ENQUIRY_CONVERSION_RATE_REPORT = 'CLEAR_ENQUIRY_CONVERSION_RATE_REPORT'
